export var ToastType;
(function (ToastType) {
    ToastType["success"] = "success";
    ToastType["error"] = "error";
    ToastType["warning"] = "warning";
})(ToastType || (ToastType = {}));
export const TOAST_ID_KEY = 'toast_';
export const TOAST_DEFAULT_HIDE_DELAY = {
    [ToastType.error]: 30000,
    [ToastType.warning]: 30000,
    [ToastType.success]: 5000,
};
